<template>
  <b-modal id="twoDimensional"
           title="Create a Two Dimensional Report"
           ok-title = "Send My Report"
           :ok-disabled="btnDisable"
           :lazy="true"
           size="lg"
           @show = "showModal"
           @ok="sendMyReport($event)"
           cancel-title="Close"
  >
    <b-container>
      <div v-show="show==='from'" class="fromcontent">
      <b-row>
        <b-col cols="2">
          Step 1
        </b-col>
        <b-col cols="7">
          Choose Report Rows
        </b-col>
        <b-col cols="2">

        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2" >

        </b-col>
        <b-col sm="7" >
          <b-select v-model="selectGeo">
            <option value="all">All</option>
            <option v-for="item in geoItems" :value="item.GeoKeyCode">{{item.GeoKeyDesc}}</option></b-select>
        </b-col>
        <b-col sm="3">
          <b-btn @click="addRows">Add</b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          Step 2
        </b-col>
        <b-col cols="7">
          Choose Report Columns
        </b-col>
        <b-col cols="2">

        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2" >

        </b-col>
        <b-col sm="7" >
          <b-select v-model="selectDemo">
            <option v-for="item in columns" :value="item.ColumnName">{{item.AttributeName}}</option>
          </b-select>
        </b-col>
        <b-col sm="3">
          <b-btn @click="addColumns">Add</b-btn>
        </b-col>
      </b-row>
      <b-row class="rprow">
        <b-col sm="2" md="2" lg="2" class="inputcol">
          Report Fields:
        </b-col>
        <b-col sm="7" md="7" lg="7">
          <b-select :select-size="8"
                    v-model="selectRF"
                    multiple>
            <option v-for="item in selectItem" :style="'margin-left:'+ item.margin + 'px'">{{item.text}}</option>
          </b-select>
          <!--(Tip: Double click to remove the selected report field.)-->
        </b-col>
        <b-col sm="5" md="4" lg="3">
          <b-btn @click="clearFields">Clear Fields</b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          Step 3
        </b-col>
        <b-col cols="7">
          Name Reports
        </b-col>
        <b-col cols="2">

        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
        </b-col>
        <b-col cols="7">
          <b-input v-model="desc"></b-input>
        </b-col>
        <b-col cols="2">

        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          Step 4
        </b-col>
        <b-col cols="7">
          Email Report to (separate multiple addresses with commas):
        </b-col>
        <b-col cols="2">

        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">

        </b-col>
        <b-col cols="7">
          <b-input v-model="targetEmail"></b-input>
        </b-col>
        <b-col cols="2">

        </b-col>
      </b-row>
        <b-row>
          <b-col>
            <b-alert :show="alertDesc!==''" class="rprow" variant="warning">{{alertDesc}}</b-alert>
          </b-col>
        </b-row>
      <!--<b-row class="rprow">-->
        <!--<b-col cols="2">-->

        <!--</b-col>-->
        <!--<b-col cols="7" class="btncol">-->
          <!--<b-btn @click="sendMyReport" :disabled="btnDisable" class="btn-primary">Send My Report</b-btn>-->
        <!--</b-col>-->
      <!--</b-row>-->
    </div>
      <div v-show="show==='success'">
        <b-row>
          <b-col>
            Thank you.
            We are processing your request now and will send an email with the report attached to
            the following email addresses when this is complete:
          </b-col>
        </b-row>
        <b-row>
        <b-col>
          <strong>{{targetEmail}}</strong>
        </b-col>
      </b-row>
        <b-row>
        <b-col>
          Reports are typically delivered within 5 minutes.
        </b-col>
      </b-row>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
    import _ from 'lodash'
    export default {
      data () {
        return {
          selectRF: [],
          selectItem: [],
          selectGeo: 'all',
          selectDemo: '',
          columns: [],
          targetEmail: '',
          selectedGeos: [],
          selectedDemos: [],
          desc: '',
          show: 'from',
          btnDisable: false,
          alertDesc: ''
        }
      },
      computed: {
        geoItems () {
          return this.$store.getters['order/geoItems']
        }
      },
      methods: {
        addRows () {
          if (this.selectGeo === 'all') {
            this.selectedGeos = this.geoItems
          } else {
            if (_.findIndex(this.selectedGeos, { GeoKeyCode: this.selectGeo }) < 0) {
              let geo = _.findIndex(this.geoItems, item => { return item.GeoKeyCode === this.selectGeo })
              this.selectedGeos.push(this.geoItems[geo])
            }
          }
          this.refush()
        },
        addColumns () {
          this.selectedDemos = []
          let demo = _.findIndex(this.columns, item => { return item.ColumnName === this.selectDemo })
          this.selectedDemos.push(this.columns[demo])
          this.refush()
        },
        clearFields () {
          this.selectedGeos = []
          this.selectedDemos = []
          this.refush()
        },
        sendMyReport (evt) {
          evt.preventDefault()
          this.alertDesc = ''
          if (this.targetEmail === '') {
            this.alertDesc += 'Please enter the email address; '
          }

          if (this.desc === '') {
            this.alertDesc += 'Please enter name of report'
          }
          if (this.selectedGeos.length === 0) {
            this.selectedGeos = this.geoItems
          }
          if (this.selectedDemos.length === 0) {
            this.selectedDemos = this.columns
          }

          if (this.alertDesc !== '') {
            return false
          }
          this.btnDisable = true
          this.$http.post('PlaceOrder.aspx/Submit2DReportConditions', {
            delimiterOfEmails: ',',
            demoCategories: this.selectedDemos,
            desc: this.desc,
            geos: this.selectedGeos,
            targetEmail: this.targetEmail,
            order: this.$store.state.order
          }, {
            errorType: 'silent'
          }).then(resp => {
            if (resp.body.d.ResultFlag) {
              this.show = 'success'
            } else {
              this.btnDisable = false
              this.alertDesc = 'Two dimensional report is not available for the selections you have made.'
            }
          }, resp => {
            this.btnDisable = false
            this.alertDesc = 'Two dimensional report is not available for the selections you have made.'
          })
        },
        refush () {
          this.selectItem = []
          if (this.selectedGeos.length > 0) {
            this.selectItem.push({'value': 'geotitle', 'margin': 0, 'text': 'Rows:'})
            this.selectItem.push({'value': 'geotitle', 'margin': 10, 'text': 'Geography'})
            for (let item of this.selectedGeos) {
              this.selectItem.push({'value': item.GeoKeyCode, 'margin': 20, 'text': item.GeoKeyDesc})
            }
          }
          if (this.selectedDemos.length > 0) {
            this.selectItem.push({'value': 'demotitle', 'margin': 0, 'text': 'Columns:'})
            for (let item of this.selectedDemos) {
              this.selectItem.push({'value': item.ColumnName, 'margin': 10, 'text': item.AttributeName})
            }
          }
        },
        getDemosFrom () {
          let that = this
          this.$http.post('PlaceOrder.aspx/GetDemosFromDemoBreakdown', {
            order: this.$store.state.order
          }).then(resp => {
            that.targetEmail = resp.body.d.DataSource.TargetEmail
            that.selectDemo = resp.body.d.DataSource.SelectedCategories[0].ColumnName
            that.columns = resp.body.d.DataSource.SelectedCategories
          }, resp => {
            // TODO@Wison add if show
            // alert('Two dimensional report is not available for the selections you have made.')
          })
        },
        showModal () {
          if (this.columns.length === 0) {
            this.getDemosFrom()
          }
          this.selectedDemos = []
          this.selectedGeos = []
          this.refush()
          this.btnDisable = false
          this.show = 'from'
        }
      }
    }
</script>

<style scoped>
.rprow{
  margin-top: 10px;
}
  .inputcol{
    text-align: right;
  }
  .btncol{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/summary/MTwoDimensional.vue